module.exports = __webpack_public_path__ + "img/ManekiGames_koban.1d26e89c.png";